import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, uploadPath } from "../helper/api.interceptor";
import "bootstrap/dist/css/bootstrap.min.css";
import { Icon } from "@iconify/react/dist/iconify.js";

function TableDetails() {
  const { id } = useParams();
  const [candidateDetails, setCandidateDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchDetails = async () => {
    setLoading(true);
    const response = await api.getInquiryById(id);
    if (response && typeof response === "object") {
      setCandidateDetails(response);
    }
    setLoading(false);
  };
  useEffect(() => {

    fetchDetails();
  }, [id]);
  const updateQuery = async (id, status) => {
    await api.updateQueryies(id, { status });
  };
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  if (loading)
    return <div className="text-center mt-5">Loading candidate details...</div>;
  if (!candidateDetails)
    return (
      <div className="text-center mt-5 text-danger">Failed to load data.</div>
    );


  const openRemarkModal = (row) => {
    setSelectedRowId(row.id);
    setRemarkInput(row.remark || "");
    setShowRemarkModal(true);
  };

  const handleRemarkSubmit = async () => {
    try {
      await api.updateQueryies(selectedRowId, { remark: remarkInput }); // Call your API
      setShowRemarkModal(false);
      setSelectedRowId(null);
      fetchDetails(); // Refresh UI after update
    } catch (err) {
      console.error("Failed to update remark", err);
    }
  };
  return (
    <div className="">
      <div className="card shadow-sm">
        <div className="card-header bg-dark">
          <h4 className="mb-0 text-white">Candidate Details</h4>
        </div>

        <div className="card-body">
          <div className="border-bottom d-flex justify-content-between">
            <h4 className="text-dark pb-2 mb-2">Personal Information</h4>
            <div className="gx-2 rounded p-1 d-flex align-items-center">
              <label className="form-label fw-bold mb-0 me-2">Change Status</label>
              <select
                className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px border-1"
                onChange={(e) => {
                  updateQuery(id, e.target.value);
                }}
              >
                <option value="null">Select Status</option>
                {
                  ['new', 'call_for_interview', 'on_hold', 'reject'].map((item, i) => {
                    const labelMap = ['New', 'Call For Interview', "On Hold", "Reject"]
                    return <option value={item}>{labelMap[i]}</option>
                  })}

              </select>
            </div>
          </div>

          {/* <div className="row gap-4 mt-3">
            {[
              { label: "Full Name", value: candidateDetails.fullName },
              { label: "Position", value: candidateDetails.position },
              { label: "Mobile Number", value: candidateDetails.mobileNumber },
              { label: "Email", value: candidateDetails.email },
              { label: "Gender", value: candidateDetails.gender },
              {
                label: "Date of Birth", value: candidateDetails.dateOfBirth ? new Date(candidateDetails.dateOfBirth).getFullYear() +
                  "/" +
                  (new Date(candidateDetails.dateOfBirth).getMonth() + 1) +
                  "/" +
                  new Date(candidateDetails.dateOfBirth).getDate() : ''
              },
              { label: "Location", value: candidateDetails.location },
              { label: "Current City", value: candidateDetails.currentCity },
              { label: "Contact No.", value: candidateDetails.mobileNumber },
            ].map(({ label, value }, idx) => (
              <div className="col-md-2 border-1 rounded p-2" key={idx}>
                <label className="form-label fw-bold">{label}</label>
                <div className="p-2 border-1 rounded">{value || "-"}</div>
              </div>
            ))}
          </div> */}

          <div className="row gy-3 mt-3">
            {[
              { label: "Full Name", value: candidateDetails.fullName },
              { label: "Position", value: candidateDetails.position },
              { label: "Mobile Number", value: candidateDetails.mobileNumber },
              { label: "Email ID", value: candidateDetails.email },
              { label: "Gender", value: candidateDetails.gender },
              {
                label: "Date of Birth",
                value: candidateDetails.dateOfBirth
                  ? new Date(candidateDetails.dateOfBirth).getFullYear() +
                  "/" +
                  (new Date(candidateDetails.dateOfBirth).getMonth() + 1) +
                  "/" +
                  new Date(candidateDetails.dateOfBirth).getDate()
                  : "",
              },
              {
                label: "Date of Application",
                value: candidateDetails.createdAt
                  ? new Date(candidateDetails.createdAt).getFullYear() +
                  "/" +
                  (new Date(candidateDetails.createdAt).getMonth() + 1) +
                  "/" +
                  new Date(candidateDetails.createdAt).getDate()
                  : "",
              },
              { label: "Location", value: candidateDetails.location },
              { label: "Current City", value: candidateDetails.currentCity },
              { label: "Contact No.", value: candidateDetails.mobileNumber },
            ].map(({ label, value }, idx) => (
              <div className="col-md-3" key={idx}>
                <div className="card shadow-sm border-1 h-100">
                  <div className="card-body">
                    <h6 className="card-title fw-semibold text-muted">{label}</h6>
                    <p className="card-text mb-0">{value || "-"}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>


          <h4 className="text-dark border-bottom pb-2 mt-3">
            Education & Career
          </h4>
          <div className="row mt-3 gy-3">
            {[
              {
                label: "Highest Qualification",
                value: candidateDetails.highestQualification,
              },
              {
                label: "College/University",
                value: candidateDetails.collegeName,
              },
              {
                label: "Year of Graduation",
                value: candidateDetails.graduationYearBachelor,
              },
              {
                label: "Year of Graduation (Master's)",
                value: candidateDetails.graduationYearMaster,
              },
              { label: "Current CTC", value: candidateDetails.currentCTC },
              { label: "Expected CTC", value: candidateDetails.expectedCTC },
              {
                label: "COA Register Number",
                value: candidateDetails.coaRegistrationNumber,
              },
              {
                label: "Years Of Experience",
                value: candidateDetails?.yearsOfExperience || '',
              },
            ].map(({ label, value }, idx) => (
              <div className="col-md-3" key={idx}>
                <div className="card shadow-sm border-1 h-100">
                  <div className="card-body">
                    <h6 className="card-title fw-semibold text-muted">{label}</h6>
                    <p className="card-text mb-0">{value || "-"}</p>
                  </div>
                </div>
              </div>
            ))}

          </div>

          <h4 className="text-dark  gy-3 mt-3">
            Additional Information
          </h4>
          <div className="row mt-3 ">
            <div className="col-md-3 ">
              <div className="card shadow-sm border-1 h-100">
                <div className="card-body">
                  <h6 className="card-title fw-semibold text-muted">LinkedIn Profile</h6>
                  <p className="card-text mb-0"> <a
                    href={candidateDetails.linkedinProfile}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {candidateDetails.linkedinProfile || "-"}
                  </a></p>
                </div>
              </div>
            </div>
            <div className="col-md-3 ">
              <div className="card shadow-sm border-1 h-100">
                <div className="card-body">
                  <h6 className="card-title fw-semibold text-muted">Portfolio</h6>
                  <p className="card-text mb-0 d-flex ">  <a
                    href={String(uploadPath + candidateDetails.portfolioUrl).replace('//uploads', '/uploads')}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {candidateDetails.portfolioUrl ? "View " : "-"}
                  </a>
                    <a
                      className="ms-2"
                      href={String(uploadPath + candidateDetails.portfolioUrl).replace('//uploads', '/uploads')}
                      download
                    >
                      {candidateDetails.portfolioUrl ? "Download " : "-"}
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 ">
              <div className="card shadow-sm border-1 h-100">
                <div className="card-body">
                  <h6 className="card-title fw-semibold text-muted">Uploaded CV</h6>
                  <p className="card-text mb-0">
                    <a
                      href={String(uploadPath + candidateDetails.cvUrl).replace('//uploads', '/uploads')}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {candidateDetails.cvUrl ? "View" : "-"}
                    </a>
                    <a
                      href={String(uploadPath + candidateDetails.cvUrl).replace('//uploads', '/uploads')}
                      download
                      className="ms-2"
                    >
                      {candidateDetails.cvUrl ? "Download " : "-"}
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 ">
              <div className="card shadow-sm border-1 h-100">
                <div className="card-body">
                  <h6 className="card-title fw-semibold text-muted">Reference Name and Mobile Number
                  </h6>
                  <p className="card-text mb-0">
                    {candidateDetails.reference1Contact}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-5 ">.
              <div className="card shadow-sm border-1 h-100">
                <div className="card-body">
                  <h6 className="card-title fw-semibold text-muted">Note to Recruiter</h6>
                  <p className="card-text mb-3">
                    {candidateDetails.noteToRecruiter || "-"}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-5 ">.
              <div className="card shadow-sm border-1 h-100">
                <div className="card-body">
                  <h6 className="card-title fw-semibold text-muted "  >Remarks     <Link
                    to="#"
                    className="w-32-px h-32-px me-8 bg-warning-light text-warning-800 rounded-circle d-inline-flex align-items-center justify-content-center
                                            "
                    onClick={() => openRemarkModal(candidateDetails)}
                  >
                    <Icon icon="iconamoon:edit" />
                  </Link> </h6>
                  <p className="card-text mb-3">
                    {candidateDetails.remark || "-"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showRemarkModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Remark</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowRemarkModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <textarea
                  rows={6}
                  className="form-control"
                  value={remarkInput}
                  onChange={(e) => setRemarkInput(e.target.value)}
                  placeholder="Enter remark"
                ></textarea>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowRemarkModal(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-dark" onClick={handleRemarkSubmit}>
                  Save Remark
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div >
  );
}

export default TableDetails;
